import Cartao from './Cartao.js'
import FIltroDatas from './FIltroDatas.js'
import ControladorPaginas from './ControladorPaginas.js'

const Eventos = (props) => {
    const qntPorPagina = 12
    const indexInicio = (props.paginaAtual - 1) * qntPorPagina
    const indexFinal = props.paginaAtual * qntPorPagina
    const eventosDaPagina = props.eventosFiltrado.slice(indexInicio, indexFinal)

    return(
        <div className='flex flex-col w-full items-center font-sans' onClick={() => props.setMenuIsOpen(false)}>
            <div className='flex items-center justify-center gap-1 w-10/12 text-black'>
                <FIltroDatas datas={props.datas} setSelectData={props.setSelectData} setsubcategoria={props.setsubcategoria} />
                
                <select value={props.subcategoria} className='flex w-2/8 max-w-[100px] gap-8 overflow-x-scroll' onChange={(evento) => props.setsubcategoria(evento.target.value)}>
                    <option value=''>{props.subcategoria != '' ? 'Remover' : 'Categoria'}</option>
                    {props.subcategorias.map((item) => {
                        return(
                            <option value={item}>{item}</option>
                        )
                    })}
                </select>

                <div className='flex-col'>
                    <select value={props.gratis} className='w-[92px] max-w-[100px]' onChange={(evento) => {
                        props.setGratis(evento.target.value)
                        props.setsubcategoria(false)
                    }}>
                        <option value=''>{props.gratis == 'Pago' || props.gratis == 'Gratis' ? 'Remover' : 'Valor'}</option>
                        <option value='Gratis'>Gratis</option>
                        <option value='Pago'>Pago</option>
                    </select>
                    {props.gratis == 'Pago' ? 
                        <div className='flex-col'>
                            <label className='text-purple-50 whitespace-nowrap'>até R$</label>
                            <input type='number' className='border w-auto md:w-6/12 max-w-12 h-1/5' onChange={(evento) => props.setSelectValor(parseInt(evento.target.value))} />
                        </div>
                    : props.gratis == 'Gratis' ? props.setSelectValor(1) : props.setSelectValor(0)}
                </div>
            </div>
            <div className='flex py-4'>{props.eventosFiltrado.length} Rolês encontrados.</div>
            <div className="w-11/12 px-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:sm:grid-cols-4 gap-10">
                {eventosDaPagina.map((item) => {
                    return(
                        <Cartao key={item} role={item} />
                    )
                })}
            </div>
            <ControladorPaginas
                eventosFiltrado={props.eventosFiltrado}
                paginaAtual={props.paginaAtual}
                qntPorPagina={qntPorPagina}
                setPaginaAtual={props.setPaginaAtual}
            />
        </div>
    )
}

export default Eventos